module.exports = __webpack_public_path__ + "media/images/success-1-875fac912457e63c94856057760f636d.png";